(function($) {
	'use strict';
    
    /* INIT ON DOM INTERACT */
    
    // Admin authors
    $(".admin-author-popup-books-btn").on("click", openBookPopup);
    $(".admin-book-list-popup").on("click", closeBookPopup);
    $(".admin-book-list-popup .admin-book-item").on("click", selectBook);
    $(".admin-book-list-popup .admin-book-list-save-btn").on("click", saveAuthorBooks);
    
    function reloadPage() {
        window.location.reload();
    }
	
	function openBookPopup(e) {
        var $item = $(this).closest(".admin-author-row");
        var bookIds = $item.attr("data-book-ids").split(",");
        var $popup = $(".admin-book-list-popup");
        var $bookList = $popup.find(".admin-book-item");
        
        // Pre-select all of the saved items
        $bookList.removeClass("selected");
        for (var i = 0; i < bookIds.length; i++) {
            $bookList.filter(".product" + bookIds[i]).addClass("selected");
        }
        $popup.attr("data-author-id", $item.attr("data-id")).show();
    }
    
    function closeBookPopup(e) {
        var ctn = e.currentTarget || this;
        var targ = e.target;
        
        if ($(targ).closest(".close-popup-btn")[0] || targ.compareDocumentPosition(ctn) === 0) {
            ctn.style.display = "none";
        }
    }
    
    function selectBook(e) {
        $(this).toggleClass("selected");
    }
    
    function saveAuthorBooks(e) {
        var $it = $(this);
        var $popup = $it.closest(".admin-book-list-popup");
        var authorId = $popup.attr("data-author-id");
        var $selectedBooks = $popup.find(".admin-book-item.selected");
        var arr = [];
        
        if (isNaN(authorId) || $it.hasClass("disabled")) {
            return; // Not a valid id, abort
        }
        
        $it.addClass("disabled");
        // Gather the ids of the selected items
        $selectedBooks.each(function() {
            arr.push(this.getAttribute("data-id"));
        });
        // Submit the data in field7
        $.ajax({
            type: "post",
            method: "post",
            url: "/action/manageGenData",
            data: "ajax=true&id=" + authorId + "&field7=" + arr.join(","),
            complete: function() {
                reloadPage();
            }
        });
    }
	
})(jQuery);
